import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { actions } from '../../../actions/telephony';
import { ExternalCallerIdModal as ExternalCallerIdModalComp } from '../../../components/sections/telephony/modals/externalCallerIdModal';

export const {
  telephonyShowExternalCallerIdModal,
  telephonyHideExternalCallerIdModal,
  telephonyVerifyExternalCallerId,
} = actions;

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootReducerStateT) => {
  return {
    meta: state.settings.telephony.meta,
    ui: state.settings.telephony.ui,
    verifyPhoneNumber: state.settings.telephony.verifyPhoneNumber,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    showExternalCallerIDModal: bindActionToPromise(
      dispatch,
      telephonyShowExternalCallerIdModal,
    ),
    hideExternalCallerIdModal: bindActionToPromise(
      dispatch,
      telephonyHideExternalCallerIdModal,
    ),
    verifyExternalCallerId: bindActionToPromise(
      dispatch,
      telephonyVerifyExternalCallerId,
    ),
  };
};

export const ExternalCallerIdModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExternalCallerIdModalComp);
